<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">资产汇总表</span></div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <Select v-model="department" :datas="departmentList" keyName="id" titleName="name" :width="180"
                placeholder="全部使用部门"></Select>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="loadList">查询</Button>
        <Button icon="fa fa-refresh" :loading="loading" @click="loadList">刷新</Button>
        <Button @click="doExport">导出</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <table class="summary-table">
        <thead>
        <tr>
          <th rowspan="2">名称</th>
          <th colspan="4">资产原值</th>
          <th colspan="4">累计折旧摊销</th>
          <th colspan="4">减值准备</th>
          <th colspan="4">资产净值</th>
          <th rowspan="2">预计净残值</th>
        </tr>
        <tr>
          <th v-for="title in subTitles" :key="title">{{ title }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in dataList" :key="index">
          <td>{{ item.name }}</td>
          <template v-for="group in groups">
            <td :key="group + 'Beginning'" align="right">{{ val(item, group, 'beginning') | numFormat }}</td>
            <td :key="group + 'Add'" align="right">{{ val(item, group, 'add') | numFormat }}</td>
            <td :key="group + 'Reduce'" align="right">{{ val(item, group, 'reduce') | numFormat }}</td>
            <td :key="group + 'Ending'" align="right">{{ val(item, group, 'ending') | numFormat }}</td>
          </template>
          <td align="right">{{ item.netSalvageValue | numFormat }}</td>
        </tr>
        <tr v-if="!dataList.length">
          <td colspan="18" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-content>
</template>

<script>
import {exportCsv} from '../../js/common/export-file';

const groups = ['originalValue', 'accumulatedDepreciation', 'impairment', 'netValue'];

const fieldMap = {
  beginning: ['beginning', 'Beginning', 'initial', 'Initial'],
  add: ['add', 'Add', 'increase', 'Increase'],
  reduce: ['reduce', 'Reduce', 'decrease', 'Decrease'],
  ending: ['ending', 'Ending', 'balance', 'Balance']
};

export default {
  name: 'AssetsSummary',
  data() {
    return {
      groups: groups,
      subTitles: ['期初', '本期增加', '本期减少', '期末'],
      department: null,
      departmentList: [],
      dataList: [],
      loading: false
    }
  },
  methods: {
    //同时兼容嵌套结构（item.originalValue.beginning）与扁平结构（item.originalBeginning）
    val(item, group, field) {
      let nested = item[group];
      if (nested && typeof nested === 'object') {
        let keys = fieldMap[field];
        for (let key of keys) {
          if (nested[key] !== undefined) {
            return nested[key];
          }
        }
      }
      let suffixes = fieldMap[field];
      for (let suffix of suffixes) {
        let flatKey = group + suffix.charAt(0).toUpperCase() + suffix.slice(1);
        if (item[flatKey] !== undefined) {
          return item[flatKey];
        }
      }
      return 0;
    },
    loadDepartments() {
      this.$api.assets.card.list({page: 1, size: 10000}).then(({data}) => {
        let cards = data.results || data.records || data || [];
        let names = {};
        cards.forEach(card => {
          if (card.department) {
            names[card.department] = card.department;
          }
        });
        this.departmentList = Object.keys(names).map(name => ({id: name, name}));
      }).catch(() => {
      });
    },
    loadList() {
      this.loading = true;
      this.$api.report.assetsSummary({department: this.department}).then(({data}) => {
        this.dataList = data || [];
      }).catch(() => {
        this.$Message.error('资产汇总表加载失败');
      }).finally(() => this.loading = false);
    },
    doExport() {
      let headers = ['名称'];
      groups.forEach(group => {
        this.subTitles.forEach(title => headers.push(group + title));
      });
      headers.push('预计净残值');
      let rows = this.dataList.map(item => {
        let row = [item.name];
        groups.forEach(group => {
          ['beginning', 'add', 'reduce', 'ending'].forEach(field => row.push(this.val(item, group, field)));
        });
        row.push(item.netSalvageValue);
        return row;
      });
      exportCsv('资产汇总表', headers, rows);
    },
    doPrint() {
      window.print();
    }
  },
  mounted() {
    this.loadDepartments();
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.summary-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;

  th, td {
    padding: 6px 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }
}
</style>
